// iFotoLife — Contenido ES (español)
import { IMG } from "./images";

const ui = {
  langLabel: "Idioma",
  backToMenu: "Menú",
  presenter: "Presentador",
  presenterNotes: "Notas del presentador",
  fullscreen: "Pantalla completa",
  exitFullscreen: "Salir",
  exportPdf: "Exportar PDF",
  share: "Compartir",
  linkCopied: "Enlace copiado al portapapeles",
  shareTitle: "Compartir esta diapositiva",
  shareText: "Vista previa personalizada para WhatsApp y LinkedIn. El enlace abre esta diapositiva.",
  copyLink: "Copiar enlace",
  slide: "Diapositiva",
  of: "de",
  next: "Siguiente",
  prev: "Anterior",
  start: "Descubrir",
  hint: "Usa ← → para navegar · F pantalla completa · N notas",
  print: "Imprimir",
};

const home = {
  eyebrow: "iFotoLife · Marketplace de fotos hospitality",
  title: "Tus recuerdos,\nencontrados de un vistazo.",
  intro:
    "La presentación comercial y el tutorial de iFotoLife — la experiencia fotográfica premium de las mejores direcciones. Elige un recorrido abajo.",
  marquee: "La experiencia fotográfica premium de las mejores direcciones —",
  cardsTitle: "Cuatro recorridos",
  cards: [
    { key: "short", index: "01", title: "Pitch comercial — Corto", meta: "10 diapositivas · 5 min", desc: "Lo esencial de la propuesta de valor, condensado para una lectura rápida." },
    { key: "full", index: "02", title: "Pitch comercial — Completo", meta: "14 diapositivas · 12 min", desc: "La presentación detallada: problema, solución, mercado, modelo y visión." },
    { key: "tutorial", index: "03", title: "Tutorial de usuario", meta: "8 pasos", desc: "La experiencia del cliente, paso a paso, de la búsqueda a la descarga HD." },
    { key: "onepager", index: "04", title: "One-page comercial", meta: "Resumen imprimible", desc: "El resumen compartible y listo para imprimir en una sola pantalla." },
  ],
  taglines: [
    "La experiencia fotográfica premium de las mejores direcciones.",
    "Del instante capturado al recuerdo entregado.",
    "El marketplace de fotos que convierte las estancias en ingresos.",
  ],
};

const modeMeta = {
  short: "Pitch comercial — Corto",
  full: "Pitch comercial — Completo",
  tutorial: "Tutorial de usuario",
};

const s_title = {
  type: "title", accent: "gold",
  overline: "Marketplace de fotos · Hospitality premium",
  title: "Tus recuerdos,\nencontrados de un vistazo.",
  lead: "iFotoLife convierte cada estancia en un recuerdo entregado — reconocimiento facial, galería personalizada, pago seguro.",
  image: IMG.familyBeach, imageAlt: "Familia sonriente en una playa tropical",
  notes: "Abre con la emoción: el recuerdo. En una frase, iFotoLife encuentra al instante las fotos de un cliente y se las entrega. Posiciona la marca como premium y hospitality desde el primer segundo.",
};

const s_problem_client = {
  type: "problem", accent: "coral",
  overline: "El problema · Lado clientes",
  title: "Los mejores momentos\nse pierden.",
  body: "Durante una estancia se toman decenas de fotos profesionales, pero los clientes nunca las encuentran o renuncian ante un proceso tedioso.",
  bullets: [
    { icon: "SearchX", title: "Fotos ilocalizables", text: "Imposible saber en qué foto apareces entre miles de imágenes." },
    { icon: "Clock", title: "Proceso lento", text: "Espera, correos, memorias USB: la experiencia rompe la magia." },
    { icon: "ImageOff", title: "Recuerdos perdidos", text: "Sin acceso sencillo, la mayoría de las fotos nunca se compran." },
  ],
  image: IMG.familyBeach, imageAlt: "Momento de vacaciones en familia",
  notes: "Insiste en la frustración: el cliente vive un momento mágico, pero el recuerdo se pierde en un proceso anticuado. Valor emocional Y comercial desperdiciado.",
};

const s_problem_hotels = {
  type: "problem", accent: "coral",
  overline: "El problema · Hoteles y fotógrafos",
  title: "Un potencial de ingresos\nsin explotar.",
  body: "Los establecimientos y fotógrafos poseen contenido de alto valor, pero sin herramienta para monetizarlo de forma simple y a escala.",
  bullets: [
    { icon: "Building2", title: "Hoteles sin palanca", text: "Ningún canal estructurado para convertir las fotos en ingresos." },
    { icon: "Camera", title: "Fotógrafos limitados", text: "Venta artesanal, logística pesada, baja conversión." },
    { icon: "TrendingDown", title: "Margen disipado", text: "Un activo premium sigue sin monetizar, estancia tras estancia." },
  ],
  image: IMG.photographer, imageAlt: "Fotógrafo profesional en un evento",
  notes: "Muestra que el problema también es económico. Hoteles y fotógrafos tienen el activo pero no la infraestructura. iFotoLife es esa infraestructura.",
};

const s_solution = {
  type: "solution", accent: "gold",
  overline: "La solución",
  title: "iFotoLife:\nel puente del instante\nal recuerdo.",
  body: "Un marketplace de fotos llave en mano que conecta hoteles, fotógrafos y clientes. El cliente se reconoce con un selfie, descubre su galería y compra en segundos.",
  bullets: [
    { icon: "ScanFace", title: "Reconocimiento facial", text: "El cliente encuentra sus fotos al instante con un simple selfie." },
    { icon: "Store", title: "Marketplace integrado", text: "Galería, carrito, pago y entrega HD en una sola experiencia." },
    { icon: "Handshake", title: "Llave en mano", text: "Sin logística para el hotel: iFotoLife opera toda la cadena." },
  ],
  image: IMG.resortPool, imageAlt: "Piscina de resort al atardecer",
  notes: "Es el núcleo del pitch: iFotoLife resuelve ambos problemas a la vez — emoción para el cliente, ingresos para el establecimiento. Una plataforma, tres ganadores.",
};

const s_journey_client = {
  type: "steps", accent: "gold",
  overline: "Recorrido · Cliente final",
  title: "Cuatro gestos,\nun recuerdo entregado.",
  steps: [
    { n: "1", title: "Escanear el QR", text: "El cliente escanea el código del establecimiento o recibe un enlace." },
    { n: "2", title: "Hacer un selfie", text: "El reconocimiento facial identifica todas sus fotos en segundos." },
    { n: "3", title: "Descubrir su galería", text: "Una selección personalizada, lista para explorar y elegir." },
    { n: "4", title: "Pagar y descargar", text: "Pago seguro, entrega HD inmediata, recuerdo garantizado." },
  ],
  mockup: "phone", mockImage: IMG.familyBeach,
  notes: "Cuenta este recorrido como una historia fluida. El cliente casi no hace nada: la tecnología se difumina tras la emoción.",
};

const s_journey_photographer = {
  type: "steps", accent: "coral",
  overline: "Recorrido · Fotógrafo asociado",
  title: "Fotografiar,\nvender, cobrar.",
  steps: [
    { n: "1", title: "Publicar sus fotos", text: "Subida rápida, indexación facial automática por evento." },
    { n: "2", title: "Venta automatizada", text: "iFotoLife gestiona el escaparate, el carrito y el pago por él." },
    { n: "3", title: "Marca de agua y protección", text: "Vista previa protegida, entrega HD solo tras la compra." },
    { n: "4", title: "Ingresos estructurados", text: "Seguimiento de ventas y liquidaciones claras y automáticas." },
  ],
  mockup: "desktop", mockImage: IMG.photographer,
  notes: "El fotógrafo pasa de la venta artesanal a un canal estructurado. Insiste en el ahorro de tiempo y la protección de su trabajo.",
};

const s_value_hotels = {
  type: "stats", accent: "gold",
  overline: "Valor · Hoteles y resorts",
  title: "Un ingreso adicional,\ncero esfuerzo.",
  body: "iFotoLife se convierte en una nueva línea de ingresos para el establecimiento — sin inversión, sin logística, sin riesgo.",
  stats: [
    { value: "+15 %", label: "de ingreso extra por establecimiento" },
    { value: "0 €", label: "de inversión inicial" },
    { value: "< 3 s", label: "para encontrar tus fotos" },
    { value: "100 %", label: "llave en mano y marca hospitality" },
  ],
  image: IMG.hotelLobby, imageAlt: "Elegante recepción de hotel moderno",
  notes: "Estas cifras son ilustrativas — adáptalas al prospecto. Mensaje clave: ingreso adicional, cero esfuerzo, cero riesgo.",
};

const s_features = {
  type: "features", accent: "gold",
  overline: "Funcionalidades clave",
  title: "Tecnología\nal servicio de la emoción.",
  bullets: [
    { icon: "ScanFace", title: "Reconocimiento facial", text: "Identificación instantánea del cliente en todas las tomas." },
    { icon: "GalleryHorizontalEnd", title: "Galería personalizada", text: "Una selección dedicada, elegante, lista para comprar." },
    { icon: "ShieldCheck", title: "Marca de agua pro", text: "Vistas previas protegidas, propiedad del fotógrafo preservada." },
    { icon: "CreditCard", title: "Pago seguro", text: "Transacción fluida, conforme y tranquilizadora." },
    { icon: "Download", title: "Entrega HD", text: "Descarga inmediata en alta definición tras la compra." },
    { icon: "QrCode", title: "Acceso QR / enlace", text: "Un punto de entrada simple, presencial o a distancia." },
  ],
  notes: "No recites la lista: conecta cada función con un beneficio. Reconocimiento facial = nunca más fotos perdidas.",
};

const s_business = {
  type: "business", accent: "gold",
  overline: "Modelo de negocio",
  title: "Una lógica\nmarketplace de ganar-ganar.",
  body: "iFotoLife opera la plataforma y reparte el valor generado entre el establecimiento, el fotógrafo y la plataforma, en cada venta.",
  bullets: [
    { icon: "Hotel", title: "Hotel", text: "Comisión en cada venta realizada en su recinto, sin esfuerzo." },
    { icon: "Camera", title: "Fotógrafo", text: "Remunerado por sus ventas, sin gestionar la logística comercial." },
    { icon: "Layers", title: "iFotoLife", text: "Opera la tecnología, el pago y la experiencia del cliente." },
  ],
  stats: [
    { value: "Comisión", label: "modelo transparente por venta" },
    { value: "Recurrente", label: "ingreso en cada estancia" },
  ],
  notes: "El modelo está alineado: nadie adelanta un coste, todos ganan con la venta. Eso facilita la adopción por parte de los hoteles.",
};

const s_usecases = {
  type: "usecases", accent: "gold",
  overline: "Casos de uso",
  title: "Donde nacen\nlos recuerdos.",
  bullets: [
    { icon: "Palmtree", title: "Resort y playa", text: "Fotos de vacaciones, atardeceres, actividades: el terreno ideal del recuerdo premium." },
    { icon: "Hotel", title: "Hotel y spa", text: "Estancias de negocios u ocio, momentos de excepción para inmortalizar." },
    { icon: "PartyPopper", title: "Evento privado", text: "Bodas, seminarios, celebraciones: una fuerte demanda fotográfica concentrada." },
  ],
  image: IMG.resortAerial, imageAlt: "Vista aérea de un resort de lujo",
  notes: "Amplía el imaginario: iFotoLife no es solo una herramienta de playa. Adapta el caso de uso al perfil del prospecto.",
};

const s_differentiation = {
  type: "list", accent: "gold",
  overline: "Diferenciación",
  title: "Por qué iFotoLife\nse impone.",
  bullets: [
    { icon: "Sparkles", title: "Experiencia premium", text: "Un estándar hospitality, alineado con las mejores direcciones." },
    { icon: "Zap", title: "Instantaneidad", text: "El reconocimiento facial elimina la fricción del filtrado manual." },
    { icon: "PackageCheck", title: "Cadena completa", text: "De la captura a la entrega HD, una sola plataforma integrada." },
    { icon: "Lock", title: "Confianza y seguridad", text: "Protección de fotos, pago seguro, datos controlados." },
  ],
  notes: "Posiciónate frente a soluciones artesanales y galerías genéricas: iFotoLife combina premium, instantaneidad y cadena completa.",
};

const s_vision = {
  type: "vision", accent: "gold",
  overline: "Visión internacional",
  title: "El estándar mundial\ndel recuerdo de estancia.",
  body: "Multilingüe por diseño, iFotoLife se despliega establecimiento a establecimiento, mercado a mercado — una red de destinos premium unidos por una misma experiencia.",
  stats: [
    { value: "3", label: "idiomas nativos: FR · EN · ES" },
    { value: "∞", label: "destinos activables" },
    { value: "1", label: "experiencia, idéntica en todas partes" },
  ],
  image: IMG.resortAerial, imageAlt: "Destino de lujo desde el cielo",
  notes: "Proyecta la ambición: iFotoLife aspira a ser un estándar internacional. El multilingüe nativo es una ventaja de despliegue inmediata.",
};

const s_faq = {
  type: "faq", accent: "gold",
  overline: "FAQ · Objeciones frecuentes",
  title: "Tus preguntas,\nnuestras respuestas.",
  faq: [
    { q: "¿El reconocimiento facial respeta la privacidad?", a: "Sí: el selfie solo sirve para encontrar tus propias fotos, con consentimiento y datos controlados." },
    { q: "¿Cuánto esfuerzo para el hotel?", a: "Ninguno. iFotoLife opera toda la cadena: implementación, tecnología, pago, soporte." },
    { q: "¿Cómo se protegen las fotos?", a: "Vistas previas con marca de agua, entrega HD solo tras la compra, propiedad del fotógrafo preservada." },
    { q: "¿Cuánto le cuesta al establecimiento?", a: "Cero inversión inicial: un modelo por comisión, alineado con las ventas reales." },
  ],
  notes: "Anticipa las objeciones clásicas: privacidad, esfuerzo, protección, coste. Mantente factual y tranquilizador.",
};

const s_cta = {
  type: "cta", accent: "gold",
  overline: "Llamada a la acción",
  title: "Hagamos de cada estancia\nun recuerdo entregado.",
  body: "Únete a iFotoLife como establecimiento o fotógrafo asociado. Activemos juntos un nuevo ingreso premium.",
  bullets: [
    { icon: "Mail", title: "Contacto", text: "contact@ifotolife.shop" },
    { icon: "Globe", title: "En línea", text: "ifotolife.shop" },
  ],
  image: IMG.resortPool, imageAlt: "Resort premium al atardecer",
  notes: "Termina con una llamada clara y una emoción. Propón un siguiente paso concreto: demo, activación piloto, contacto directo.",
};

const s_problem_merged = {
  type: "problem", accent: "coral",
  overline: "El problema",
  title: "Recuerdos perdidos,\ningresos sin explotar.",
  body: "Para los clientes, las fotos se pierden en un proceso anticuado. Para hoteles y fotógrafos, un activo premium sigue sin monetizar.",
  bullets: [
    { icon: "SearchX", title: "Fotos ilocalizables", text: "El cliente nunca encuentra las tomas en las que aparece." },
    { icon: "Building2", title: "Hoteles sin palanca", text: "Ningún canal estructurado para convertir fotos en ingresos." },
    { icon: "Camera", title: "Fotógrafos limitados", text: "Venta artesanal, logística pesada, baja conversión." },
  ],
  image: IMG.photographer, imageAlt: "Fotógrafo en un evento",
  notes: "Versión condensada: presenta el doble problema (emoción + economía) en una diapositiva, y pasa rápido a la solución.",
};

const s_journey_merged = {
  type: "steps", accent: "gold",
  overline: "Los recorridos",
  title: "Cliente y fotógrafo,\nla misma fluidez.",
  steps: [
    { n: "1", title: "El cliente escanea", text: "QR o enlace, luego un selfie para encontrar sus fotos." },
    { n: "2", title: "Se abre su galería", text: "Selección personalizada, pago y entrega HD." },
    { n: "3", title: "El fotógrafo publica", text: "Subida e indexación facial automáticas." },
    { n: "4", title: "Se realiza la venta", text: "iFotoLife gestiona escaparate, pago y liquidaciones." },
  ],
  mockup: "phone", mockImage: IMG.familyBeach,
  notes: "Fusión de ambos recorridos: muestra la simetría de la experiencia del cliente y del fotógrafo.",
};

const full = [s_title, s_problem_client, s_problem_hotels, s_solution, s_journey_client, s_journey_photographer, s_value_hotels, s_features, s_business, s_usecases, s_differentiation, s_vision, s_faq, s_cta];
const short = [s_title, s_problem_merged, s_solution, s_journey_merged, s_value_hotels, s_features, s_business, s_usecases, s_differentiation, s_cta];

const tutorial = [
  { type: "tutorial", accent: "gold", step: "01", overline: "Paso 1", title: "Bienvenido\na iFotoLife.", body: "Encuentra y descarga las fotos de tu estancia en segundos. Sigue la guía.", mockup: "phone", mockImage: IMG.familyWatermelon, mockTitle: "iFotoLife", notes: "Tranquiliza: la experiencia es simple y rápida. Da ganas de empezar." },
  { type: "tutorial", accent: "gold", step: "02", overline: "Paso 2", title: "Encuentra\ntu lugar.", body: "Escanea el código QR del establecimiento o abre el enlace recibido para acceder a tu evento.", mockup: "phone", mockImage: IMG.resortActivities, mockTitle: "Tu estancia", notes: "Muestra las dos entradas: QR presencial o enlace a distancia." },
  { type: "tutorial", accent: "gold", step: "03", overline: "Paso 3", title: "Inicia\nla búsqueda.", body: "Usa el reconocimiento facial para encontrar tus fotos, o explora libremente la galería del evento.", mockup: "phone", mockImage: IMG.familyPool, mockTitle: "Búsqueda", notes: "Dos opciones: reconocimiento facial (rápido) o navegación por galería (libre)." },
  { type: "tutorial", accent: "gold", step: "04", overline: "Paso 4", title: "Hazte\ntu selfie.", body: "Un simple selfie basta: iFotoLife identifica al instante todas las fotos donde apareces.", mockup: "phone", mockImage: IMG.familyPool, mockTitle: "Selfie", notes: "Insiste en la simplicidad: un selfie y listo. Datos usados solo para la búsqueda." },
  { type: "tutorial", accent: "gold", step: "05", overline: "Paso 5", title: "Descubre\ntu galería.", body: "Todas tus fotos, reunidas en una galería personalizada, listas para explorar.", mockup: "phone", mockImage: IMG.familyPoolDad, mockTitle: "Mi galería", notes: "Momento de placer: el cliente redescubre sus recuerdos, bellamente presentados." },
  { type: "tutorial", accent: "gold", step: "06", overline: "Paso 6", title: "Selecciona\ny añade al carrito.", body: "Elige tus favoritas y añádelas al carrito con un gesto.", mockup: "phone", mockImage: IMG.brandPhotographer, mockTitle: "Carrito", notes: "Recuerda la facilidad de selección: un toque para añadir, vista previa clara." },
  { type: "tutorial", accent: "gold", step: "07", overline: "Paso 7", title: "Paga\ncon seguridad.", body: "Paga en segundos con un pago seguro y tranquilizador.", mockup: "payment", mockTitle: "Pago", notes: "Tranquiliza sobre la seguridad del pago. Transacción fluida y conforme." },
  { type: "tutorial", accent: "gold", step: "08", overline: "Paso 8", title: "Descarga\ntus fotos HD.", body: "Tus recuerdos en alta definición, disponibles de inmediato. Listos para compartir.", mockup: "phone", mockImage: IMG.familyWatermelon, mockTitle: "Descarga", notes: "Cierra con la satisfacción: el recuerdo entregado, en HD, al instante." },
];

const onepager = {
  eyebrow: "One-page comercial",
  title: "iFotoLife",
  slogan: "Tus recuerdos, encontrados de un vistazo.",
  intro: "iFotoLife es el marketplace de fotos premium para hoteles, resorts y eventos. Con reconocimiento facial, cada cliente encuentra sus fotos con un selfie y las descarga en HD — generando un ingreso adicional llave en mano para el establecimiento y el fotógrafo.",
  problemTitle: "El problema",
  problem: "Las fotos de estancia se pierden en un proceso anticuado; hoteles y fotógrafos no tienen herramienta para monetizar de forma simple este activo premium.",
  solutionTitle: "La solución",
  solution: "Una plataforma llave en mano: reconocimiento facial, galería personalizada, marca de agua pro, pago seguro y entrega HD. Tres ganadores, una experiencia.",
  argsTitle: "5 argumentos clave",
  args: [
    "Reconocimiento facial instantáneo — nunca más fotos perdidas.",
    "Ingreso adicional llave en mano para hoteles y resorts.",
    "Ventas estructuradas y automatizadas para los fotógrafos.",
    "Experiencia de cliente premium alineada con los estándares hospitality.",
    "Pago seguro + entrega HD + marca de agua pro.",
  ],
  statsTitle: "Cifras clave",
  stats: [
    { value: "+15 %", label: "de ingreso extra" },
    { value: "< 3 s", label: "para encontrar tus fotos" },
    { value: "0 €", label: "de inversión inicial" },
    { value: "3", label: "idiomas: FR · EN · ES" },
  ],
  audienceTitle: "Para quién",
  audience: ["Hoteles y resorts", "Fotógrafos asociados", "Inversores y socios", "Clientes finales"],
  ctaTitle: "Seamos socios",
  cta: "Activemos juntos un nuevo ingreso premium para tu establecimiento. Contacto: contact@ifotolife.shop · ifotolife.shop",
};

export const es = { ui, home, modeMeta, decks: { full, short, tutorial }, onepager };
